import type React from 'react';
import classNames from 'classnames';

import styles from './LoadingBarWithBanner.module.scss';

interface LoadingBarWithBannerProps {
    showLoadingBar: boolean;
    /** `inverse` is the dark strip in both themes; `plain` sits on the card it is in. */
    surface?: 'inverse' | 'plain';
    bottomLoadingEdgesRound?: 'none' | 'all' | 'top' | 'bottom';
    children?: React.ReactNode;
}

function LoadingBarWithBanner({
    showLoadingBar = false,
    surface = 'inverse',
    bottomLoadingEdgesRound = 'bottom',
    children,
}: LoadingBarWithBannerProps) {
    return (
        <div className={classNames(styles.loadingScreen, styles[surface])}>
            <div className={styles.loadingTextContainer}>{children}</div>
            {showLoadingBar && (
                <div className={styles.loadingBar} data-edges-round={bottomLoadingEdgesRound} />
            )}
        </div>
    );
}

export default LoadingBarWithBanner;
export { LoadingBarWithBanner };
